import * as React from 'react'
import { styled } from 'next-yak'

import type * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as utils from '@owl-nest/utils'
import * as plume from '@ulule/owl-kit-components/next'

type SocialSquareProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'color'> & {
  platform: api.LinkServiceType
  url: string
}

export function SocialSquare({ children, platform, url }: SocialSquareProps): React.ReactElement<SocialSquareProps> {
  return (
    <Anchor href={url} target="_blank" rel="nooponer noreferrer">
      <Content>
        <plume.SquarePlatformIcon platform={platform} />
        <plume.styles.heading.XXXS>{children || utils.platform.getLabel(platform)}</plume.styles.heading.XXXS>
      </Content>
    </Anchor>
  )
}

const Anchor = styled.a`
  padding: 0px;
  text-align: left;
  text-decoration: none;

  &:hover {
    cursor: pointer;
  }

  ${plume.SquarePlatformIcon} {
    margin-right: 13px;
  }
`

const Content = styled.span`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${plume.styles.heading.XXXS} {
    word-break: break-word;
  }
`
